import axios from 'axios';
import { redirectToAuth } from './redirect';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend-kfammeublement.onrender.com';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor to add the auth token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('showroom_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor to handle expired tokens


api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('showroom_token');
            localStorage.removeItem('showroom_user');
            redirectToAuth(); // utilise la fonction
        }
        return Promise.reject(error);
    }
);


export default api;
